var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplitInUpToPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 143,
    viewBox: "0 0 142 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.8002 38.1941C70.1503 38.9068 70.3816 39.67 70.4852 40.4547L72.3994 68.9166L73.3496 83.2222C73.3594 84.6934 73.5902 86.155 74.0346 87.5601C75.1822 90.2862 77.943 92.0188 80.9466 91.898L126.715 88.9042C128.697 88.8715 130.611 89.6128 132.036 90.9649C133.223 92.0916 133.99 93.5656 134.231 95.1509L134.312 96.1136C132.418 122.34 113.157 144.214 86.9849 149.861C60.8132 155.508 33.9753 143.579 21.0424 120.552C17.3139 113.862 14.9851 106.509 14.1926 98.9241C13.8616 96.6787 13.7158 94.4107 13.7567 92.1423C13.7159 64.0249 33.7389 39.7164 61.7673 33.8562C65.1407 33.331 68.4477 35.1168 69.8002 38.1941Z",
    fill: "#E3E9F2",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M88.482 13.7555C119.831 14.5531 146.179 37.0959 151.251 67.4594L151.202 67.6834L151.064 68.0092L151.083 68.9036C151.011 70.0885 150.554 71.2286 149.765 72.1495C148.944 73.1087 147.822 73.762 146.587 74.0155L145.833 74.1189L93.0277 77.5403C91.2712 77.7135 89.5224 77.1472 88.2161 75.9821C87.1276 75.0112 86.4317 73.7005 86.2351 72.2883L82.6908 19.5597C82.6291 19.3814 82.6291 19.1881 82.6908 19.0098C82.7392 17.5564 83.379 16.1825 84.4672 15.1952C85.5554 14.2079 87.0013 13.6894 88.482 13.7555Z",
    fill: "#E3E9F2",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitInUpToPayment);
export default __webpack_public_path__ + "static/media/split-in-up-to-payment.4417c667262c053a10a6c92625f8da34.svg";
export { ForwardRef as ReactComponent };